import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ButtonUI from '../../../components/UI/ButtonUI';
import { isNullOrEmpty, translate, configs } from '../../../utils/util';
import Breadcrumbs from '../../../components/UI/Breadcrumbs';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { Card, SelectDock, SelectResource, SelectShed } from '../../../components/UI/ComponentsUI';
import { ENUMS } from '../../../utils/constants';
import SecurityService from '../../../services/SecurityService';
import { getVision } from '../../../services/auth';

const ReceiptParameters = (props) => {
    const [config, setConfig] = useState({});
    const [model, setModel] = useState({
        resource: props.user.resource || '',
        shed: props.user.shed || '',
        dock: props.user.dock || ''
    });

    useEffect(() => {
        document.addEventListener('keydown', handleFormKeyDown);

        if (isNullOrEmpty(model.shed) && !isNullOrEmpty(props.user.shed)) {
            model.shed = props.user.shed;
        }

        if (isNullOrEmpty(model.dock) && !isNullOrEmpty(props.user.dock)) {
            model.dock = props.user.dock;
        }

        if (isNullOrEmpty(model.resource) && !isNullOrEmpty(props.user.resource)) {
            model.resource = props.user.resource;
        }

        setModel({ ...model });
        return () => {
            document.removeEventListener('keydown', handleFormKeyDown);
        }
        // eslint-disable-next-line
    }, [props.user.resource, props.user.shed, props.user.dock]);


    useEffect(() => {
        if (!props.config?.items || !isNullOrEmpty(props.location?.state?.filterContainer)) {
            props.loadConfig(getVision(), ENUMS.eModules.PhysicalConfirmation.value)
        }
        setConfig(configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items));
        // eslint-disable-next-line
    }, [props.config, props.config?.items]);


    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const handleFormKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            submit();
        }
    }

    const submit = () => {
        if (validateInputsRequired("formParamsCf")) {
            if (!Boolean(config.shedRequiredPhysicalConfirmation)) {
                props.setShed("", {});
            }
            if (!isNullOrEmpty(props.location?.state?.filterContainer)) {
                props.history.replace({
                    pathname: '/receipt/V2/receiptStorages',
                    state: {
                        filterContainer: true,
                        forceSearch: true,
                        mvmNumber: props.location.state.filtermvmNumber,
                        journey: props.location.state.filterJourney
                    },
                    ...props
                });
            } else {
                props.history.push({ pathname: '../V2/home', ...props });
            }
        }
    }

    return (
        <div>
            <Breadcrumbs id="receiptParameters" title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('menu.configuration', 'configuration') }}
                subtitles={[{ icon: "mdi mdi-clipboard-check", label: translate('menu.physical-confirmation', 'configuration') }]} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        <div>
                            <form className="col s12">
                                <div id="formParamsCf" className="row" style={{ marginBottom: '0px' }}>
                                    {Boolean(config.shedRequiredPhysicalConfirmation) &&
                                        <>
                                            <div className="input-field col s12">
                                                <SelectShed
                                                    unload
                                                    id="shed"
                                                    required
                                                    name="shed"
                                                    value={model.shed}
                                                    onChange={onChange}
                                                />
                                            </div>
                                        </>

                                    }{Boolean(config.dockRequiredPhysicalConfirmation) &&
                                        <>
                                            <div className="input-field col s12">
                                                <SelectDock
                                                    unload
                                                    id="dock"
                                                    required
                                                    name="dock"
                                                    filterArea
                                                    shedId={model.shed}
                                                    value={model.dock}
                                                    onChange={onChange}

                                                />
                                            </div>
                                        </>

                                    }
                                    <div className="input-field col s12">
                                        <SelectResource
                                            id="resource"
                                            required
                                            name="resource"
                                            filterArea
                                            shedId={model.shed}
                                            value={model.resource}
                                            onChange={onChange}
                                        />
                                    </div>

                                </div>
                            </form>
                        </div>
                        <div className="row" style={{ paddingTop: '10px' }}>
                            <div className="col s6">
                                <ButtonUI full="true" onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                            </div>
                            <div className="col s6">
                                <ButtonUI full="true" onClick={() => submit()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        resource: state.configReducer.resource,
        shed: state.configReducer.shed,
        dock: state.configReducer.dock,
        config: state.configReducer.config,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setShed: (shed, shedObj) => {
            dispatch(SecurityService.setShed(shed, shedObj));
        },
        loadConfig: (vision, module) => {
            dispatch(SecurityService.loadConfig(vision, module));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReceiptParameters));
